$(document).ready(function() {      
jQuery(".trendy-category1").owlCarousel({
	responsive: {
                0: {
                    items: 2
                },
                480: {
                    items: 3,
                },

                767: {
                    items: 5
                },
                768: {
                    items: 6
                },
                992: {
                    items: 7
                },
                1170: {
                    items: 8
                },
                1280: {
                    items: 9
                },
                1560: {
                    items: 10
                },
            },
            stagePadding: 3,
            loop: false,
            mouseDrag : false,
            autoWidth: true,
            nav: true,
            dots:false,
            margin: 5,
            lazyLoad: true,
            afterInit: setWidth()
        });
        function setWidth(){
            setTimeout(function(){
                var carWidth = $('.trendy-category1 .owl-stage').width() + 100;
                $('.trendy-category1 .owl-stage').width(carWidth);
            },200);

        }

    var owl = $("#slider-carousel");
    owl.owlCarousel({
    responsive:{
    0:{
    items:3
    },
    468:{
    items:4,
    },
    568:{
    items:5,
    },
    668:{
    items:6,
    },
    768:{
    items:7
    },
    992:{
    items:9
    },
    1170:{
    items:10
    },
    1280:{
    items:11
    },
    1560:{
    items:13
    },
    },
         stagePadding: 0,
         autoplay:true,
         stopOnHover: true,
         loop:false,
         rewindNav:false,
         navigation:false,
         margin:15,
         lazyLoad: true,
         scrollPerPage: true,
    	 nav:true,
         onLoadedLazy:function(){
	  $("#slider-carousel").find(".owl-lazy").each(function(){
                $(this).attr('alt',$(this).data('alt'));
          });
	 }
    });
        var collection_slider = $(".collection-slider");
        collection_slider.owlCarousel({
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 50
                },
                480: {
                    items: 2,
                    stagePadding: 50
                },
                768: {
                    items: 3,
                    stagePadding: 50
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                },
                1560: {
                    items: 5
                }
            },
            autoplay: false,
            loop: false,
            //rewindNav:false,
            scrollPerPage: true,
            lazyLoad: true,
            nav: true,
            margin: 10
        });
        var trendy_slider = $(".trendy-slider");
        trendy_slider.owlCarousel({
            responsive: {
                0: {
                    items: 2,
                    stagePadding: 30
                },
                480: {
                    items: 3,
                    stagePadding: 30
                },
                768: {
                    items: 4,
                    stagePadding: 10
                },
                992: {
                    items: 4,
                    stagePadding: 0
                },
                1200: {
                    items: 5
                },
                1560: {
                    items: 7
                }
            },
            autoplay: false,
            loop: false,
            slideBy: 'page',
            lazyLoadEager: 1,
            //rewindNav:false,
            lazyLoad: true,
            nav: true,
            margin: 10
        });
	// var shapefilter = $(".shapefilter");
    //     shapefilter.owlCarousel({
    //         responsive: {
    //             0: {
    //                 items: 3,
    //                 stagePadding: 30
    //             },
    //             480: {
    //                 items: 5,
    //                 stagePadding: 30
    //             },
    //             768: {
    //                 items: 6,
    //                 stagePadding: 10
    //             },
    //             992: {
    //                 items: 7,
    //                 stagePadding: 0
    //             },
    //             1200: {
    //                 items: 10
    //             },
    //             1560: {
    //                 items: 12
    //             }
    //         },
    //         autoplay: false,
    //         loop: false,
    //         autoWidth: false,
    //         mouseDrag : false,
    //         //rewindNav:false,
    //         scrollPerPage: true,
    //         lazyLoad: true,
    //         nav: true,
    //         margin: 10,
	//         onInitialized:function(){
    //             $(".shapefilter").show();
    //         }
    //     });

    });
